/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        valid_from
        valid_to
        user_id
        user_email
        arena_number
        title
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getExternalEvent = /* GraphQL */ `
  query GetExternalEvent($id: ID!) {
    getExternalEvent(id: $id) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const listExternalEvents = /* GraphQL */ `
  query ListExternalEvents(
    $filter: ModelExternalEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listExternalEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        valid_from
        valid_to
        user_id
        user_email
        arena_number
        title
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const externalEventsByDate = /* GraphQL */ `
  query ExternalEventsByDate(
    $valid_from: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelExternalEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    externalEventsByDate(
      valid_from: $valid_from
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        valid_from
        valid_to
        user_id
        user_email
        arena_number
        title
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
